import { useEffect, useMemo, useState } from 'react';
import call from '~/assets/icons/call.svg';
import message from '~/assets/icons/message_2.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { PhoneApps } from '~/shared';
import { ContactsStages } from '../../models/Contacts';
import { MessengerStages } from '../../models/Messenger';
import {
	setActiveApp,
	setActiveContactsState,
	setActiveMessengerState,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { AppBackButton } from '../AppBackButton';
import {
	StyledAvatar,
	StyledButtonsContainer,
	StyledContainer,
	StyledHead,
	StyledInfoContainer,
	StyledInfoItem,
	StyledStarIcon,
} from './AppContactsInfoContact.styled';

const AppContactsInfoContact = () => {
	const dispatch = useLayoutDispatch();
	const selectedContact = useLayoutSelector(
		(state) => state.contacts.selectedContact,
	);
	const contacts = useObservable(rage.contacts.getContacts());
	const dialogs = useObservable(rage.messages.getDialogs());
	const [isFavoriteHover, setIsFavoriteHover] = useState(false);

	const liveContact = useMemo(
		() =>
			selectedContact
				? contacts.find((c) => c.phoneNumber === selectedContact.phoneNumber) ??
				  selectedContact
				: null,
		[contacts, selectedContact],
	);

	const handleCall = () => {
		if (!liveContact) return;
		rage.phoneCalls
			.call(liveContact.phoneNumber)
			.catch((err) => rage.notifications.showException(err));
	};

	const handleMessage = async () => {
		if (!liveContact) return;
		const dialog = dialogs.find(
			(d) => d.peer.phoneNumber === liveContact.phoneNumber,
		);
		if (dialog) {
			rage.messages.setActiveDialogId(dialog.id);
			dispatch(setActiveApp(PhoneApps.MESSENGER));
			dispatch(setActiveMessengerState(MessengerStages.DIALOG));
			return;
		}
		try {
			const dialogId = await rage.messages.createDialog(
				liveContact.phoneNumber,
				'',
			);
			rage.messages.setActiveDialogId(dialogId);
			dispatch(setActiveApp(PhoneApps.MESSENGER));
			dispatch(setActiveMessengerState(MessengerStages.DIALOG));
		} catch (e) {
			rage.notifications.showException(e);
		}
	};

	const handleToggleFavorite = async () => {
		if (!liveContact) return;
		try {
			await rage.contacts.toggleFavorite(liveContact.phoneNumber);
		} catch (e) {
			rage.notifications.showException(e);
		}
	};

	const handleRemove = async () => {
		if (!liveContact) return;
		try {
			await rage.contacts.removeContact(liveContact.phoneNumber);
			dispatch(setActiveContactsState(ContactsStages.ALL_CONTACTS));
		} catch (e) {
			rage.notifications.showException(e);
		}
	};

	useEffect(() => {
		if (!selectedContact) {
			dispatch(setActiveContactsState(ContactsStages.ALL_CONTACTS));
		}
	}, [selectedContact]);

	if (!liveContact) {
		return null;
	}

	return (
		<div>
			<StyledHead>
				<AppBackButton
					onClick={() =>
						dispatch(setActiveContactsState(ContactsStages.ALL_CONTACTS))
					}
				/>
				<Text>{liveContact.name}</Text>
			</StyledHead>
			<StyledContainer>
				<StyledAvatar>
					<Text>{liveContact.name.slice(0, 1).toUpperCase()}</Text>
				</StyledAvatar>
				<StyledButtonsContainer>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height60}
						onClick={handleCall}
					>
						<img src={call} alt="call" />
					</Button>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height60}
						onClick={handleMessage}
					>
						<img src={message} alt="message" />
					</Button>
					<Button
						color={
							liveContact.isFavorite ? ButtonColors.Gold : ButtonColors.Default
						}
						height={ButtonHeight.Height60}
						onClick={handleToggleFavorite}
						onMouseEnter={() => setIsFavoriteHover(true)}
						onMouseLeave={() => setIsFavoriteHover(false)}
					>
						<StyledStarIcon
							style={{
								backgroundColor: isFavoriteHover
									? '#000000'
									: liveContact.isFavorite
									? '#FFB500'
									: '#ffffff',
							}}
						/>
					</Button>
				</StyledButtonsContainer>
				<StyledInfoContainer>
					<StyledInfoItem>
						<Text>Имя</Text>
						<Text>{liveContact.name}</Text>
					</StyledInfoItem>
					<StyledInfoItem>
						<Text>Номер</Text>
						<Text>{liveContact.phoneNumber}</Text>
					</StyledInfoItem>
				</StyledInfoContainer>
				<Button
					color={ButtonColors.Cancel}
					height={ButtonHeight.Height50}
					style={{ width: 340, marginTop: 35 }}
					onClick={handleRemove}
				>
					<Text>Удалить контакт</Text>
				</Button>
			</StyledContainer>
		</div>
	);
};

export { AppContactsInfoContact };
